import { call, put, takeLatest } from 'redux-saga/effects';
import { getOkveds, getPopularOkveds } from 'modules/Taps/services/API';
import { GET_OKVEDS, GET_POPULAR_OKVEDS } from './actionTypes';
import {
  getOkvedsFailure,
  getOkvedsSuccess,
  getPopularOkvedsFailure,
  getPopularOkvedsSuccess,
} from './actions';

function* getOkvedsSaga(action) {
  const response = yield call(getOkveds, action.payload);
  yield put(response.isOk ? getOkvedsSuccess(response.data) : getOkvedsFailure(response.error));
}

function* getPopularOkvedsSaga(action) {
  const response = yield call(getPopularOkveds, action.payload);

  yield put(
    response.isOk
      ? getPopularOkvedsSuccess(response.data)
      : getPopularOkvedsFailure(response.error),
  );
}

export default function* okvedsSaga() {
  yield takeLatest(GET_OKVEDS, getOkvedsSaga);
  yield takeLatest(GET_POPULAR_OKVEDS, getPopularOkvedsSaga);
}
